import { MaterialRequirements as MaterialRequirementsValue } from '../../calculations/components/shipment-creation-form/types/form-values'
import { DataSourceItem } from '../shipments-page'

/** То же преобразование, что раньше задавалось через fieldDescriptors для ячейки. */
export function getMaterialRequirementsFormInitialValues(
    record: DataSourceItem
): MaterialRequirementsValue[] | undefined {
    return record.materialRequirements?.map(mr => ({
        componentId: mr.id != null ? String(mr.id) : null,
        materialTypeName: mr.material_type?.name,
        materialTypeDocId: mr.material_type?.documentId,
        configurations: mr.configurations?.map(config => ({
            componentId: config.id != null ? String(config.id) : null,
            material: config.material?.documentId,
            amount: config.amount,
            action: config.action,
        })),
    })) as MaterialRequirementsValue[] | undefined
}
